// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1yW_s","selectedRecruiterLabel":"_3oRDl","selectedRecruiterContainer":"uAK5h","selectedRecruiterName":"_3yzbM","cancelButton":"_2F3kG"};